export default function (cli) {
  return {
    list (shopPk, date) {
      return cli.get(`${cli.apiEndpoint}shifts/`).query({
        shop: shopPk,
        date: date,
      })
    },

    shiftList (shopPk, year, month) {
      return cli.get(`${cli.apiEndpoint}shift-list/${year}/${month}/`).query({shop: shopPk})
    },

    shiftCreate (data) {
      return cli.post(`${cli.apiEndpoint}shifts/`).send(data)
    },
    shiftUpdate (pk, data) {
      return cli.patch(`${cli.apiEndpoint}shifts/${pk}/`).send(data)
    },
    shiftDelete (pk) {
      return cli.del(`${cli.apiEndpoint}shifts/${pk}/`)
    },

    planList (shopPk, year, month) {
      return cli.get(`${cli.apiEndpoint}shift-plans/${year}/${month}/`).query({shop: shopPk})
    },

    planCreate (data) {
      return cli.post(`${cli.apiEndpoint}shift-plans/`).send(data)
    },

    planUpdate (pk, data) {
      return cli.patch(`${cli.apiEndpoint}shift-plans/${pk}/`).send(data)
    },

    planDelete (pk) {
      return cli.del(`${cli.apiEndpoint}shift-plans/${pk}/`)
    },

    planCheckChange (shop, date, status) {
      const data = {
        shop,
        date,
        status,
      }
      return cli.post(`${cli.apiEndpoint}shift-plan-checks/`).send(data)
    },

    planApply (shopPk, year, month) {
      const data = {
        shop: shopPk,
        year,
        month,
      }
      return cli.post(`${cli.apiEndpoint}shift-plan-apply/`).send(data)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/shifts.js